import { useTranslation } from 'next-i18next'

import { useAppSelector } from '~/redux/hooks'
import { selectStreakDays } from '~/redux/slices/user'

export default function DashboardStreakCard(): React.ReactElement {
  const { t } = useTranslation('dashboard')
  const streakDays = useAppSelector(selectStreakDays) ?? 0

  return (
    <div className="flex flex-col justify-between items-center bg-purple-cosmos p-3 border border-white-veil rounded-4 w-full h-full text-center">
      <h2 className="font-bold text-white text-4.5 leading-7">{t('dashboard:streak.title')}</h2>
      <p className="text-13 lg:text-16 leading-none">🔥</p>
      <p className="font-bold text-orange-amber text-6.5 leading-8">
        {t('dashboard:streak.days', { count: streakDays })}
      </p>
      {streakDays > 0 ? (
        <div className="text-white/60 text-3.25 leading-5">
          <p>{t('dashboard:streak.keepItUp')}</p>
          <p>{t('dashboard:streak.dontBreakTheChain')}</p>
        </div>
      ) : (
        <p className="text-white/60 text-3.25 leading-5">{t('dashboard:streak.logInTomorrow')}</p>
      )}
    </div>
  )
}
